export const docketsList = ({ caseDockets: { list = [] } }) => list;

export const docketsCount = ({ caseDockets: { count = 0 } }) => count;

export const docketsTypes = ({ caseDockets: { docketsTypes = [] } }) => docketsTypes;

export const docketsClaimList = ({ caseDockets: { claimsList = [] } }) =>
  claimsList.map(({ id, claimNumber }) => ({
    id,
    name: claimNumber,
  }));



// WEBPACK FOOTER //
// ./src/store/selectors/caseDockets.js